module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2htIo"))).then(() => parcelRequire('fThBo'));